import { condicionIvaApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'CONDICION_IVA',
  api: condicionIvaApi,
  relUrl: '',
});
